var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 33C5 17.536 17.536 5 33 5C48.464 5 61 17.536 61 33C61 48.464 48.464 61 33 61C17.536 61 5 48.464 5 33Z",
    fill: "#E0F2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6667 26.0001C44.6667 24.7167 43.6167 23.6667 42.3334 23.6667H23.6667C22.3834 23.6667 21.3334 24.7167 21.3334 26.0001M44.6667 26.0001V40.0001C44.6667 41.2834 43.6167 42.3334 42.3334 42.3334H23.6667C22.3834 42.3334 21.3334 41.2834 21.3334 40.0001V26.0001M44.6667 26.0001L33 34.1667L21.3334 26.0001",
    stroke: "#0086C9",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56C20.2975 56 10 45.7025 10 33H0C0 51.2254 14.7746 66 33 66V56ZM56 33C56 45.7025 45.7025 56 33 56V66C51.2254 66 66 51.2254 66 33H56ZM33 10C45.7025 10 56 20.2975 56 33H66C66 14.7746 51.2254 0 33 0V10ZM33 0C14.7746 0 0 14.7746 0 33H10C10 20.2975 20.2975 10 33 10V0Z",
    fill: "#F0F9FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeGlow);
export default __webpack_public_path__ + "static/media/envelope-glow.3a29fa2e7dee3052c866480cd784ba2d.svg";
export { ForwardRef as ReactComponent };